import { FC } from 'react';
import { FieldMetaProps } from 'formik';
import { AutoComplete, AutoCompleteProps } from 'antd';
import { kebabCase } from 'lodash';
import { StyledAutocompleteWrapper, StyledSearchIcon } from './styles';
import Input from 'components/new-ui/base/input/Input';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';

interface Props extends Omit<AutoCompleteProps, 'placeholder'> {
    inputPlaceholder?: string;
    fieldMeta?: FieldMetaProps<any>;
    label?: string;
    fieldName?: string;
    required?: boolean;
}

const FormAutocomplete: FC<Props> = ({
    label,
    required,
    fieldName,
    inputPlaceholder,
    fieldMeta,
    size,
    disabled,
    ...rest
}) => {
    const isError = Boolean(fieldMeta?.touched && fieldMeta.error);

    const autoCompleteEl = (
        <>
            <StyledAutocompleteWrapper error={isError}>
                <AutoComplete
                    allowClear
                    disabled={disabled}
                    {...(rest.onSearch
                        ? { onSearch: rest.onSearch }
                        : {
                              filterOption: (inputValue, option) =>
                                  option?.label?.toString().toUpperCase().indexOf(inputValue.toUpperCase()) !== -1,
                          })}
                    {...rest}
                >
                    <Input
                        id={fieldName}
                        size={size || 'middle'}
                        bordered={false}
                        placeholder={inputPlaceholder ?? ''}
                        suffix={<StyledSearchIcon />}
                        data-testid={`${kebabCase(inputPlaceholder ?? 'default')}-search-bar`}
                        disabled={disabled}
                    />
                </AutoComplete>
            </StyledAutocompleteWrapper>

            {fieldMeta?.touched && fieldMeta.error && (
                <div style={{ color: 'var(--error-normal)' }}>{fieldMeta.error}</div>
            )}
        </>
    );

    if (label) {
        return (
            <label htmlFor={fieldName}>
                {required && <LabelRequiredSymbol style={{ marginRight: 8 }} />}
                {label}
                {autoCompleteEl}
            </label>
        );
    }

    return autoCompleteEl;
};

export const { Option } = AutoComplete;
export default FormAutocomplete;
